import Vue from 'vue';
import axios from 'axios';
import {
  DELETE_USER,
  FETCH_USERS_FAILED,
  FETCH_USERS_SUCCESS,
  UNBAN_USER,
  TOGGLE_SPINNER,
} from '../mutation-types';

export const state = {
  all: [],
  isLoading: false,
};

export const mutations = {
  [FETCH_USERS_SUCCESS](state, users) {
    state.all = users;
  },

  [FETCH_USERS_FAILED](state) {
    state.all = [];
  },

  [DELETE_USER](state, user) {
    let index = state.all.indexOf(user);
    state.all.splice(index, 1);
  },

  [UNBAN_USER](state, user) {
    let index = state.all.indexOf(user);
    Vue.set(state.all, index, user);
  },

  [TOGGLE_SPINNER](state) {
    state.isLoading = !state.isLoading;
  },
};

export const actions = {
  async fetch({ commit }) {
    try {
      const { data: { data } } = await axios.get('/api/users');
      commit(FETCH_USERS_SUCCESS, data);
    } catch (e) {
      commit(FETCH_USERS_FAILED);
    }
  },

  async store({ dispatch, commit }, user) {
    try {
      dispatch('toggleSpinner');

      const { data: { data } } = await axios.post('/api/users', user);
      commit(CREATE_USER, data);

      dispatch('toast', 'User created.', { root: true });
    } catch (e) {
      throw e;
    } finally {
      dispatch('toggleSpinner');
    }
  },

  async unban({ dispatch, commit }, user) {
    try {
      dispatch('toggleSpinner');

      user.status = 'active';

      await axios.patch(`/api/users/${user.id}/unban`);
      commit(UNBAN_USER, user);

      dispatch('toast', 'User unflagged.', { root: true });
    } catch(e) {
      dispatch('toast', {
        message: 'Something went wrong.',
        type: 'is-danger'
      }, { root: true });
    } finally {
      dispatch('toggleSpinner');
    }
  },

  async destroy({ dispatch, commit }, user) {
    try {
      dispatch('toggleSpinner');

      await axios.delete(`/api/users/${user.id}`);
      commit(DELETE_USER, user);

      dispatch('toast', 'User deleted.', { root: true });
    } catch(e) {
      dispatch('toast', {
        message: 'Something went wrong.',
        type: 'is-danger'
      }, { root: true });
    } finally {
      dispatch('toggleSpinner');
    }
  },

  toggleSpinner({ commit }) {
    commit(TOGGLE_SPINNER);
  },
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/users.js